module.exports = __webpack_public_path__ + "img/welcome-page-img4.b3636746.svg";